import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ServiceList from "./ServiceList";
import MainContentLayout from "../../components/Layout/MainContentLayout";
import { useLocation, useParams } from "react-router-dom";
import ViewService from "./ViewService";

export default function Service() {
    const menuDispatch = useDispatch();
    const { id } = useParams();
    const path = useLocation().pathname;

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'service'
        });
    }, [menuDispatch]); // Added menuDispatch to dependency array

    return (
        <>
            {path.startsWith('/admin/service-details/') && id ? 
                <ViewService />
                :
                <ServiceList />
            }
        </>
    );
}